import { useState } from 'react';
import { formatInr } from '../../utils/bookingUtils';

const MobileStickyBar = ({
  total,
  lineItems = [],
  currency,
  onContinue,
  disabled,
  label,
  onBack,
  backLabel = 'Back',
}) => {
  const [open, setOpen] = useState(false);

  const detailsId = 'mobile-summary-details';

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-[#E6DED1] bg-[#FFFDFC]/95 px-4 py-3 shadow-[0_-12px_30px_rgba(16,35,61,0.12)] backdrop-blur lg:hidden">
      {open && (
        <div id={detailsId} className="mb-3 space-y-2 rounded-2xl border border-[#E6DED1] bg-white px-4 py-3 text-sm text-[#243444]">
          {lineItems.map((row) => (
            <div key={row.label} className="flex justify-between">
              <span className="text-[#667085]">{row.label}</span>
              <span className="font-medium text-[#10233D]">{formatInr(row.value, currency)}</span>
            </div>
          ))}
        </div>
      )}
      <div className="flex items-center justify-between gap-3">
        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          aria-expanded={open}
          aria-controls={detailsId}
          className="text-left text-sm font-semibold text-[#10233D]"
        >
          Total {formatInr(total, currency)}
          <div className="text-xs font-normal text-[#667085]">{open ? 'Hide details' : 'View details'}</div>
        </button>
        <div className="flex items-center gap-2">
          {onBack && (
            <button
              type="button"
              onClick={onBack}
              className="rounded-full border border-[#E6DED1] px-3 py-2 text-xs font-semibold text-[#667085]"
            >
              {backLabel}
            </button>
          )}
          <button
            type="button"
            onClick={onContinue}
            disabled={disabled}
            className="rounded-full bg-[#0F5C5A] px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-[#0A4443] disabled:opacity-60"
          >
            {label}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileStickyBar;
